export default __webpack_public_path__ + "static/media/asset 27.63f1dbeb.png";